import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import "./styles/fonts.css";

import { SnackbarProvider } from "notistack";
import * as Sentry from "@sentry/react";
import { NotAuthorizedError } from "./api-client/base";
import { localStorage } from "./utils";

if (
  import.meta.env.VITE_SENTRY_DSN &&
  import.meta.env.VITE_SENTRY_DSN.length > 0
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
    integrations: [],
  });
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      onError={(error) => {
        if (
          error instanceof NotAuthorizedError &&
          error.message === "User is not logged in or token expired"
        ) {
          localStorage.removeItem("role");
          window.location.href = "/login";
        }
      }}
    >
      <SnackbarProvider maxSnack={3}>
        <App />
      </SnackbarProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
